import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Fuel, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-6">
      <div className="w-full max-w-sm animate-fadeUp">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center">
            <Fuel className="w-6 h-6 text-black" />
          </div>
          <span className="font-[Outfit] font-bold text-2xl text-white">Fuel Tracer</span>
        </div>
        {done ? (
          <div data-testid="forgot-confirmation">
            <h2 className="font-[Outfit] font-bold text-2xl text-white mb-2">Check your inbox</h2>
            <p className="text-[#9CA3AF] text-sm">
              If that email is registered, a reset link has been sent. It expires in 1 hour.
            </p>
            <Link to="/login" className="inline-block mt-6 text-emerald-400 text-sm hover:underline">← Back to sign in</Link>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="forgot-form">
            <h2 className="font-[Outfit] font-bold text-2xl text-white mb-1">Reset password</h2>
            <p className="text-[#9CA3AF] text-sm mb-6">Enter your account email and we'll send a reset link.</p>
            {error && <div className="mb-4 text-sm text-red-400">{error}</div>}
            <Label htmlFor="email" className="text-[#9CA3AF]">Email</Label>
            <Input
              id="email" type="email" data-testid="forgot-email-input" value={email}
              onChange={(e) => setEmail(e.target.value)} required
              className="mt-1.5 bg-[#111827] border-[#374151] text-white"
            />
            <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
              className="w-full mt-6 bg-emerald-500 hover:bg-emerald-400 text-black font-semibold">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </Button>
            <Link to="/login" className="block mt-4 text-center text-emerald-400 text-sm hover:underline">← Back to sign in</Link>
          </form>
        )}
      </div>
    </div>
  );
}
